import {
  Button,
  Card,
  CardContent,
  Divider,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import { useRef } from 'react';
import generatePDF, { Margin } from 'react-to-pdf';
import DownloadIcon from '@mui/icons-material/Download';
import PatientData from './PatientData';
import ClinicDetails from 'app/views/Patient/components/ClinicDetails';

const useStyles = makeStyles({
  table: {
    minWidth: 650
  },
  headerCell: {
    borderBottom: '2px solid black'
  },
  tableHead: {
    backgroundColor: '#C5C6C7'
  }
});

const calculateTotal = (data) => {
  return data?.reduce((total, item) => total + item.price, 0);
};

const calculateBalance = (data) => {
  return data?.reduce((total, item) => total + item.balance, 0);
};

const Component = ({ handleInvoiceDialogClose, selectedItems }) => {
  // console.log('pdfData', selectedItems);
  var fileee = selectedItems[0]?.refPatientName || ''

  const options = {
    filename: `${fileee}_Invoice.pdf`,
    page: {
      margin: Margin.MEDIUM,
      format: 'A4'
    }
  };
  const targetRef = useRef();
  const classes = useStyles();
  return (
    <div>
      <div ref={targetRef}>
        <Card style={{ margin: '20px', border: '2px solid black' }}>
          <CardContent>
            <ClinicDetails />
            <Grid container xs={6} style={{ marginTop: '20px' }}>
              <Grid item xs={6}>
                <Typography>
                  <b>Invoice Number</b>
                </Typography>
                <Typography>88774455</Typography>
              </Grid>
              <Grid item xs={6}>
                <Typography>
                  <b>Date</b>
                </Typography>
                <Typography>22 March 2024</Typography>
              </Grid>
            </Grid>
            <Grid container xs={6} style={{ marginTop: '2vh' }}>
              <PatientData id={selectedItems} />
            </Grid>
            <Grid container spacing={2} style={{ marginTop: '10px' }}>
              <Grid item xs={12}>
                <TableContainer component={Paper}>
                  <Table className={classes.table} aria-label="simple table">
                    <TableHead className={classes.tableHead}>
                      <TableRow>
                        <TableCell
                          className={classes.headerCell}
                          align="center"
                          style={{ width: '10%' }}
                        >
                          Sr.No
                        </TableCell>
                        <TableCell
                          className={classes.headerCell}
                          align="center"
                          style={{ width: '30%' }}
                        >
                          Treatment
                        </TableCell>
                        <TableCell
                          className={classes.headerCell}
                          align="center"
                          style={{ width: '10%' }}
                        >
                          Price
                        </TableCell>
                        <TableCell
                          className={classes.headerCell}
                          align="center"
                          style={{ width: '10%' }}
                        >
                          Balance
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {selectedItems?.map((item, index) => (
                        <TableRow key={index}>
                          <TableCell align="center">{index + 1}</TableCell>
                          <TableCell align="center">{item.refTreatmentPlan}</TableCell>
                          <TableCell align="center">₹ {item.price} </TableCell>
                          <TableCell align="center"> ₹ {item.balance} </TableCell>
                        </TableRow>
                      ))}
                      <TableRow>
                        <TableCell colSpan={2} />
                        <TableCell align="right">
                          {' '}
                          <div style={{ textAlign: 'left' }}>Total</div>
                        </TableCell>
                        <TableCell align="center">₹ {calculateTotal(selectedItems)}</TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell colSpan={2} />
                        <TableCell align="right">
                          {' '}
                          <div style={{ textAlign: 'left' }}>Balance</div>
                        </TableCell>
                        <TableCell align="center">₹ {calculateBalance(selectedItems)}</TableCell>
                      </TableRow>
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </div>
      <Button
        variant="contained"
        color="primary"
        style={{ backgroundColor: '#66b5a3', color: 'white' }}
        sx={{ height: 1 }}
        onClick={() => {
          generatePDF(targetRef, options, { filename: 'page.pdf' });
          handleInvoiceDialogClose();
        }}
        startIcon={<DownloadIcon />}
      >
        PDF
      </Button>
    </div>
  );
};
export default Component;
